export const CLIENT_GENDER_OPTIONS = [
  'Male',
  'Female',
  'Non-Binary',
  'Other',
  'Prefer Not to Answer',
] as const;
export type ClientGender = (typeof CLIENT_GENDER_OPTIONS)[number];

export const CLIENT_RACE_2020_OPTIONS = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Some Other Race',
  'Two or More Races',
  'Prefer Not to Answer',
] as const;
export type ClientRace2020 = (typeof CLIENT_RACE_2020_OPTIONS)[number];

export const CLIENT_ETHNICITY_2020_OPTIONS = [
  'Hispanic or Latino',
  'Not Hispanic or Latino',
  'Prefer Not to Answer',
] as const;
export type ClientEthnicity2020 = (typeof CLIENT_ETHNICITY_2020_OPTIONS)[number];

interface ClientDemographicInput {
  phone?: string | null;
  email?: string | null;
  race2020?: ClientRace2020 | null;
  ethnicity2020?: ClientEthnicity2020 | null;
  gender?: ClientGender | null;
  genderOtherText?: string | null;
  zipCode?: string | null;
  consentOnFileToReferOut?: boolean;
  consentOnFileToReferOutDate?: string | null;
}

interface ClientCoreInput {
  clientUniqueId: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  birthdate: string;
  reasonForInitialContact: string;
}

interface ClientDemographicDetail {
  phone: string | null;
  email: string | null;
  race2020: ClientRace2020 | null;
  ethnicity2020: ClientEthnicity2020 | null;
  gender: ClientGender | null;
  genderOtherText: string | null;
  zipCode: string | null;
  consentOnFileToReferOut: boolean;
  consentOnFileToReferOutDate: string | null;
}

interface ClientCoreDetail {
  clientUniqueId: string | null;
  enrollmentDate: string | null;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  birthdate: string | null;
  reasonForInitialContact: string | null;
}

export interface ClientLookupRequest {
  lastName: string;
  birthdate: string;
}

export interface ClientLookupMatch {
  id: number;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  birthdate: string;
}

export interface ClientLookupResponse {
  matches: ClientLookupMatch[];
}

export interface CreateClientRequest extends ClientCoreInput, ClientDemographicInput {}

export interface CreateClientResponse {
  client: {
    id: number;
  };
}

export interface ClientCaseSummaryCounts {
  open: number;
  closed: number;
  total: number;
}

export interface ClientDetailApiModel {
  id: number;
  createdByUserId: number;
  createdAt: string;
  preferredName: string | null;
  address: string | null;
  status: 'open' | 'closed';
}

export interface ClientDetailApiModel extends ClientCoreDetail, ClientDemographicDetail {}

export interface GetClientDetailResponse {
  client: ClientDetailApiModel;
  caseSummary: ClientCaseSummaryCounts;
}

export interface UpdateClientProfileRequest extends ClientCoreInput, ClientDemographicInput {
  enrollmentDate: string;
}

export interface UpdateClientProfileResponse {
  client: ClientDetailApiModel;
}

export interface UpdateClientStatusRequest {
  status: 'open' | 'closed';
}

export interface UpdateClientStatusResponse {
  client: ClientDetailApiModel;
}

export interface ClientCaseApiModel {
  id: number;
  caseUniqueId: string;
  clientId: number;
  assignedPartnerOrganizationId: number | null;
  serviceId: number | null;
  serviceName: string | null;
  partnerName: string | null;
  referralSource: 'hospital' | 'school' | 'community_based_organization' | 'self' | 'other';
  referralSourceOther: string | null;
  referralDate: string;
  status: 'open' | 'closed' | 'declined_closed';
  priority: 'low' | 'medium' | 'high';
  openedAt: string;
  closedAt: string | null;
  createdByUserId: number;
  updatedAt: string;
}

export interface GetClientCasesResponse {
  data: ClientCaseApiModel[];
  count: number;
}